import {
  useGlobalCurrency,
  useIncome,
  useReportBespoke,
  useStructureGrouping,
} from "@iliotech/data-wire";
import { ColumnChartStacked, ValueLegend } from "src/main";
import { ReportWidgetProps } from "../../ReportWidgetProps";
import { useProjectedFutureIncomeWidget } from "./hooks/useProjectedFutureIncomeWidget";
import { useParams } from "react-router-dom";

export const ProjectedFutureIncomeWidget = ({
  height,
  width,
  isHalfHeight,
  structureContext,
}: ReportWidgetProps) => {
  const { currencyFormatter } = useGlobalCurrency();
  const { selectedGroup } = structureContext || useStructureGrouping();
  const { portfolioId } = useParams<{ portfolioId: string }>();
  const incomeReport = useIncome(portfolioId!).data?.data as any;
  const {
    futureIncomeTotals,
    futureIncomeData,
    futureDate,
    futureIncomeTitle,
  } = useProjectedFutureIncomeWidget({
    futureIncome: incomeReport?.futureIncome || [],
    structureContext,
  });

  const store = useReportBespoke();
  const generating = store.generating;

  if (selectedGroup?.code === "CryptoCurrencies") {
    return null;
  }
  return (
    <div>
      <h4 className={"element-title"}>{futureIncomeTitle}</h4>
      <p className={"period-string"}>{futureDate}</p>
      <ColumnChartStacked
        height={height}
        width={width}
        generating={generating}
        data={futureIncomeData}
        hideLegend
        valueFormatter={currencyFormatter!}
      />
      <ValueLegend small={isHalfHeight} items={futureIncomeTotals} />
    </div>
  );
};
